import { SET_SELECTED_AGENCY } from './types';

export const setSelectedAgency = (agency) => ({
    type: SET_SELECTED_AGENCY,
    payload: agency,
});